export default {
    THERE_IS_EQUITY:'Yes,they do',
    NO_EQUITY:'No, lets give them {{type}}',
    GENERATE:'No, let\'s generate them {{agreement}}'
}